import {SectionPadding} from '@/section';
import {withBgOrange50, withNeutral900, withGreen300} from '@/hocs/withColors';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {H2, H3, P, PNoMargin} from '@/typography';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import PictureWrapper from '@/ui/images-wrapper';
import {withMd, withPNoMargin, withBoldWeight} from '@/hocs/withFontType';
import {withMarginBottomXl, withMarginBottomXlToSm} from '@/hocs/withSpacing';
import styles from '@/content/shared/quote.module.scss';

const imgPath = '/static/images/roi-calculator/features-roi/';

const FeaturesRoiSectionPadding = withBgOrange50(SectionPadding);

const DivMarginedBottomXl = withMarginBottomXl('div');
const DivMargined = withMarginBottomXlToSm('div');
const SubP = withMd(withBoldWeight(withNeutral900(withPNoMargin(P))));
const Green300Span = withGreen300('span');

const FeaturesRoi = () => (
  <FeaturesRoiSectionPadding>
    <Container>
      <Grid fluid>
        <Row center="xs">
          <Col xs={12} lg={8}>
            <H2>How we deliver these savings</H2>
            <P>Let’s break down how Workable’s features contribute to your savings.</P>
          </Col>
        </Row>
        <DivMargined>
          <GridLayout Col={3} lgCol={2} autoRows>
            <GridItem Col={1} Row={1}>
              <BoxGrid>
                <H3>Reduce time to hire</H3>
                <PNoMargin>
                  Workable streamlines your hiring process with one-click job posting to 200+ job
                  boards and AI-powered candidate sourcing. Our automated scheduling system and
                  intuitive mobile app keep your hiring process moving efficiently, wherever you
                  are.
                </PNoMargin>
              </BoxGrid>
            </GridItem>
            <GridItem Col={1} Row={1}>
              <BoxGrid>
                <H3>Improve quality of hires</H3>
                <PNoMargin>
                  Make better hiring decisions with our structured interview kits, scorecards, and
                  integrated assessment tools. Our collaboration features and data-driven insights
                  help you identify top talent consistently and fairly.
                </PNoMargin>
              </BoxGrid>
            </GridItem>
            <GridItem Col={1} lgCol={2} Row={1}>
              <BoxGrid>
                <H3>Increase HR productivity</H3>
                <PNoMargin>
                  Automate offer approvals, manage multiple candidates with bulk actions, and
                  customize your hiring pipeline to match your unique process. Smart candidate
                  profiles consolidate all information in one place, saving your team valuable time.
                </PNoMargin>
              </BoxGrid>
            </GridItem>
          </GridLayout>
        </DivMargined>
        <GridLayout Col={2} autoRows>
          <GridItem Col={1} lgCol={2} Row={1} Order={1}>
            <BoxGrid>
              <H3>Reduce external costs</H3>
              <PNoMargin>
                Conduct video interviews, assessments, and powerful candidate sourcing all within
                Workable. Our comprehensive feature set reduces your need for external tools and
                services, consolidating your recruiting spend.
              </PNoMargin>
            </BoxGrid>
          </GridItem>
          <GridItem Col={1} lgCol={2} Row={1} Order={3}>
            <BoxGrid>
              <H3>Prevent regulatory fines</H3>
              <PNoMargin>
                Workable automates compliance with GDPR, EEO/OFCCP & CCPA, and protects your data
                with ISO and SOC-2 certified security measures. Our granular permissions system
                ensures data is only accessible to authorized personnel, reducing the risk of costly
                fines and data breaches.
              </PNoMargin>
            </BoxGrid>
          </GridItem>
          <GridItem Col={1} Row={2} Order={2}>
            <BoxGrid backgroundColor="transparent" border="orange200">
              <DivMarginedBottomXl>
                <PictureWrapper
                  imgPath={imgPath}
                  imageUrl="quote"
                  imageTypeFallback="png"
                  altImage="Kristi Stevens Picture"
                  loading="lazy"
                />
              </DivMarginedBottomXl>
              <P className={styles.quote}>
                “The self-scheduling feature is by far one of my favorites because the back and
                forth between myself, candidates and managers was one of my biggest stressors before
                Workable. It probably took up more time than anything, so when the self scheduler
                came along I was so happy. <Green300Span>It made my life 10X easier</Green300Span>.”
              </P>
              <SubP>Kristi Stevens - Head of Talent, Frosch Travel</SubP>
            </BoxGrid>
          </GridItem>
        </GridLayout>
      </Grid>
    </Container>
  </FeaturesRoiSectionPadding>
);

export default FeaturesRoi;
